import React, { useState } from "react";
// import "./navbar.css";

import { Box, Button, Container, Divider, Typography } from "@mui/material";
import navbarcss from "./navbarcss";
import { Link } from "react-router-dom";

import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { ExpandMore } from "@mui/icons-material";
import US from "../../assets/flags/us.png";
import JDOE from "../../assets/jdoe.jpg";
import { Menu, Modal } from "@mantine/core";
import LanguagesMenu from "../headermenus/LanguagesMenu";
import currencies from "../../data/currencies";
import CurrencyMenu from "../headermenus/CurrencyMenu";
import ProfileMenu from "../headermenus/ProfileMenu";
import ClearIcon from "@mui/icons-material/Clear";
import RegisterForm from "../forms/RegisterForm";
import LoginForm from "../forms/LoginForm";
import useFirebaseAuth from "../../context/useFirebaseAuth";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { getAuth, signOut } from "firebase/auth";
import { colors } from "../../configs";

const Navbar = () => {
  const { authUser, loggedUser, logOut } = useFirebaseAuth();
  const [selLanguage, setSelLanguage] = useState<any | null>({
    title: "English",
    code: "us",
    flag: US,
  });

  const [selCurrency, setSelCurrency] = useState<any | null>(currencies[1]);

  const onLanguageSelect = (selLang: any) => {
    setSelLanguage(selLang);
  };
  const onCurrencySelect = (selCur: any) => {
    setSelCurrency(selCur);
  };

  let [loginOpened, setLoginOpened] = useState<boolean>(false);
  let [registerOpened, setRegisterOpened] = useState<boolean>(false);

  const handleLogClose = () => {
    setLoginOpened(false);
  };
  const handleLogOpen = () => {
    setLoginOpened(true);
  };

  const handleRegClose = () => {
    setRegisterOpened(false);
  };
  const handleRegOpen = () => {
    setRegisterOpened(true);
  };

  const signOut = () => {
    logOut()
      .then(() => {
        console.log("deconnecté");
      })
      .catch((err) => {
        console.log("IMPOSSIBLE DE VOUS DECONNECTER: ", err);
      });
    /*
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        // Sign-out successful.
      })
      .catch((error) => {
        // An error happened.
      });
    */
  };
  return (
    <>
      <Box className="navbar" sx={navbarcss.navbar}>
        <Container className="navContainer" sx={navbarcss.navContainer}>
          <Menu
            trigger="hover"
            openDelay={100}
            closeDelay={400}
            closeOnClickOutside={true}
            closeOnEscape={true}>
            <Menu.Target>
              <Link
                className="support"
                to={"#"}
                style={{
                  color: "#999999",
                  fontSize: "13px",
                }}>
                {`${selCurrency.iso.code}`}
              </Link>
            </Menu.Target>
            <CurrencyMenu onChoiceDone={onCurrencySelect} />
          </Menu>
          <Menu
            trigger="hover"
            openDelay={100}
            closeDelay={400}
            closeOnClickOutside={true}
            closeOnEscape={true}>
            <Menu.Target>
              <Link
                className="support"
                to={"#"}
                style={{
                  color: "#999999",
                  fontSize: "13px",
                }}>
                <img
                  src={selLanguage.flag}
                  style={{
                    display: "inline",
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    marginLeft: "5px",
                  }}
                />
              </Link>
            </Menu.Target>
            <LanguagesMenu onChoiceDone={onLanguageSelect} />
          </Menu>
          <Link
            className="support"
            to={"#"}
            style={{
              color: "#999999",
              fontSize: "13px",
            }}>
            <NotificationsNoneIcon />
          </Link>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              color: "#ffffff",
              backgroundColor: "#ffffff",
              width: "2px",
              height: "30px",
            }}
          />
          {!authUser ? (
            <>
              <Link to="#" onClick={handleLogOpen} className="authBtns">
                <Typography
                  sx={{
                    backgroundColor: "#FFFFFF",
                    color: colors.main,
                    padding: "2px 10px",
                    borderRadius: "5px",
                    "&: hover": {
                      backgroundColor: colors.main,
                      color: "#FFFFFF",
                    },
                  }}>
                  Login
                </Typography>
              </Link>
              <Link to="#" onClick={handleRegOpen} className="authBtns">
                <Typography
                  sx={{
                    backgroundColor: "#FFFFFF",
                    color: colors.main,
                    padding: "2px 10px",
                    borderRadius: "5px",
                    "&: hover": {
                      backgroundColor: colors.main,
                      color: "#FFFFFF",
                    },
                  }}>
                  Register
                </Typography>
              </Link>
            </>
          ) : (
            <>
              <Menu
                trigger="hover"
                openDelay={100}
                closeDelay={400}
                closeOnClickOutside={true}
                closeOnEscape={true}>
                <Menu.Target>
                  <Link
                    className="support"
                    to={"#"}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      textAlign: "center",
                      alignItems: "center",
                    }}>
                    <img
                      src={JDOE}
                      style={{
                        display: "inline",
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        marginRight: "5px",
                      }}
                    />
                    <Typography
                      variant="inherit"
                      component="i"
                      sx={{
                        color: "#404040",
                        fontSize: "13px",
                        padding: "1px 3px 1px 3px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "10px",
                      }}>
                      {authUser.firstname ? authUser.firstname : authUser.email}
                      <ExpandMore />
                    </Typography>
                  </Link>
                </Menu.Target>
                <ProfileMenu />
              </Menu>
              <Link
                to="#"
                style={{
                  padding: "3px 7px",
                  backgroundColor: "#FFFFFF",
                  color: "red",
                  borderRadius: "10px",
                }}
                onClick={signOut}>
                <PowerSettingsNewIcon sx={{ color: "red" }} />
              </Link>
            </>
          )}
        </Container>
      </Box>
      <Modal
        opened={loginOpened}
        onClose={handleLogClose}
        centered
        withCloseButton={false}>
        <Button
          variant="contained"
          onClick={handleLogClose}
          sx={{
            position: "absolute",
            top: -20,
            right: -20,
            width: "15px",
            height: "15px",
            padding: "30px",
            borderRadius: "50%",
            //  zIndex: 3,
          }}>
          <ClearIcon sx={{ color: "#FFFFFF" }} />
        </Button>

        <LoginForm />
      </Modal>
      <Modal
        opened={registerOpened}
        onClose={handleRegClose}
        centered
        withCloseButton={false}>
        <Button
          variant="contained"
          onClick={handleRegClose}
          sx={{
            position: "absolute",
            top: -20,
            right: -20,
            width: "15px",
            height: "15px",
            padding: "30px",
            borderRadius: "50%",
            //  zIndex: 3,
          }}>
          <ClearIcon sx={{ color: "#FFFFFF" }} />
        </Button>
        <RegisterForm />
      </Modal>
    </>
  );
};

export default Navbar;
